import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaMap, FaStream, FaGolfBall, FaComments, FaUser, FaChevronDown } from 'react-icons/fa';
import './MobileNavbar.css';
import axiosInstance from "../axiosConfig";

const MobileNavbar = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true); // Navbar visibility
  const [isCollapsed, setIsCollapsed] = useState(false); // Navbar collapse state
  const [showToggle, setShowToggle] = useState(false); // Toggle button visibility
  const [pendingCount, setPendingCount] = useState(0); // State for pending requests count
  const [isClubUser, setIsClubUser] = useState(false); // Club user state

  // Check if user is a club user (from localStorage)
  useEffect(() => {
    const checkClubStatus = () => {
      try {
        const userProfile = localStorage.getItem('user_profile');
        if (userProfile) {
          const profile = JSON.parse(userProfile);
          setIsClubUser(profile.is_club === true);
        }
      } catch (e) {
        setIsClubUser(false);
      }
    };
    checkClubStatus();
  }, [location.pathname]); // Re-check when route changes

  // Define paths where the navbar should be hidden
  const hiddenPaths = ['/','/home','/login', '/register', '/Register', '/register/', '/unsubscribe', '/myclub/register/', '/reset-password/', '/', '/contact', '/termsofservice', '/privacypolicy', '/privacy-choices', '/profile-setup', '/checkout', '/myclub/login'];

  // Define path prefixes where navbar should be hidden (for dynamic routes)
  const hiddenPathPrefixes = ['/myclub/dashboard'];

  const handleScroll = () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.offsetHeight;

    // Only show the toggle button when at the bottom of the page and navbar is collapsed
    if (scrollPosition >= pageHeight - 5 && isCollapsed) {
      setShowToggle(true);
    } else {
      setShowToggle(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isCollapsed]); // Re-run when collapsed state changes

  const isActive = (path) => location.pathname === path;

  const isCoursesPage = location.pathname === '/courses'; // Check if on the courses page

  // Conditionally hide navbar (check both exact paths and path prefixes)
  const shouldHideNavbar = hiddenPaths.includes(location.pathname) ||
    hiddenPathPrefixes.some(prefix => location.pathname.startsWith(prefix));

  return (
    !shouldHideNavbar && (
      <>
        {/* Toggle button for hiding/showing the navbar */}
        {isCoursesPage && showToggle && (
          <div
            className="navbar-collapse-toggle"
            onClick={() => setIsCollapsed(false)} // Restore the navbar
          >
            <FaChevronDown />
            Show Navbar
          </div>
        )}
        {/* Mobile Navbar */}
        <div
          className={`mobile-navbar ${isVisible ? 'visible' : 'hidden'} ${
            isCoursesPage && isCollapsed ? 'collapsed' : ''
          }`}
        >
          <Link to="/feestable" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
            <FaGolfBall />
            <span>Home</span>
          </Link>
          <Link to="/feed" className={`nav-item ${isActive('/feed') ? 'active' : ''}`}>
            <FaStream />
            <span>Feed</span>
          </Link>
          <Link to="/courses" className={`nav-item ${isActive('/courses') ? 'active' : ''}`}>
            <FaMap />
            <span>Map</span>
          </Link>
          <Link to="/forums" className={`nav-item ${isActive('/forums') ? 'active' : ''}`}>
            <FaComments />
            <span>Forums</span>
          </Link>
          {!isClubUser && (
            <Link to="/myiq" className={`nav-item ${isActive('/myiq') ? 'active' : ''}`}>
              <FaUser />
              <span>My IQ</span>
              {pendingCount > 0 && <span className="notification-icon-navbar">{pendingCount}</span>}
            </Link>
          )}
        </div>
        {/* Hide Navbar Button */}
        {isCoursesPage && !isCollapsed && (
          <div
            className="navbar-collapse-toggle"
            onClick={() => setIsCollapsed(true)} // Collapse the navbar
          >
            <FaChevronDown />
            Hide Navbar
          </div>
        )}
      </>
    )
  );
};

export default MobileNavbar;
